/**
 * TanStack Query キーファクトリ
 *
 * @graph-stack quality-atelier
 * @graph-domain Quality
 * @graph-business TanStack Queryキーファクトリ。auth/dashboard/anomaliesのキャッシュキーを一元管理
 * @graph-connects none
 */

export const queryKeys = {
  auth: {
    all: ['auth'] as const,
    user: () => [...queryKeys.auth.all, 'user'] as const,
  },
  dashboard: {
    all: ['dashboard'] as const,
    kpi: (date?: string) => ['dashboard', 'kpi', date] as const,
    kpiTrend: (days?: number) => ['dashboard', 'kpi-trend', days] as const,
    summary: (date?: string) => ['dashboard', 'summary', date] as const,
  },
  anomalies: {
    all: ['anomalies'] as const,
    list: (params?: Record<string, unknown>) => ['anomalies', 'list', params] as const,
  },
};
